var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDash = function SvgDash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5 9.372V8.253c-.026-.086-.051-.717-.077-.86a8.243 8.243 0 0 0-.103-.833c-.18-1.033-.412-1.865-.9-2.726-.103-.2-.232-.402-.335-.574-.206-.287-.36-.459-.591-.717-.052-.058-.052-.086-.103-.115-.67-.631-.824-.746-1.647-1.234C22.15.304 19.86.075 18.06.046H8.001c-.078.574-.85 5.08-.824 5.165 1.878 0 3.73.03 5.608.03h2.804c2.213 0 5.094.085 6.046 2.61.566 1.607.205 3.788-.155 5.424-.308 1.434-.617 2.726-1.415 3.873-.128.201-.334.46-.488.632-1.03 1.061-2.161 1.55-3.628 1.808-.874.172-1.723.2-2.65.2h-2.803c-1.39-.028-2.804 0-4.193 0-.463 0-.978-.028-1.415 0l-.823 5.166c.36.028.797 0 1.183 0h8.18c3.062 0 5.197-.03 7.872-1.636.412-.23 1.055-.717 1.39-1.033.05-.058.128-.115.18-.172l.051-.058.386-.401c.103-.086.489-.517.591-.66.155-.23.335-.43.515-.718.18-.23.334-.488.489-.746.154-.287.283-.545.437-.832a16.94 16.94 0 0 0 1.08-2.697 27.11 27.11 0 0 0 1.004-5.424c.026-.172.051-1.119.077-1.205Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15.054v.028c.36.03.797 0 1.158 0h8.129c.72 0 1.492.058 2.16-.172 1.364-.43 1.776-1.492 2.059-2.898.077-.344.154-.689.205-1.033.052-.23.206-.89.206-1.062-3.087-.028-6.174 0-9.26 0-1.313 0-2.702-.114-3.577 1.206-.334.487-.488 1.119-.643 1.836l-.334 1.578c-.026.086-.077.46-.103.517Z",
    fill: "#fff"
  })));
};

export { SvgDash as ReactComponent };
export default __webpack_public_path__ + "dash.svg";